import type { VoidFunctionComponent } from 'react';
import Licensing from './Licensing';
import Security from './Security';
import Quality from './Quality';
import Containers from './Containers';
import Header from '../../../shared/settings/SettingsPageHeader';
import { shouldDisplayProjectIssueSettings } from '../../shared/permissions';
import OrganizationSettingsPermissionGate from '../../OrganizationSettingsPermissionGate';
import { usePolicies } from '../../../shared/policies/hooks';
import Loader from '../../../generic/Loader';
import { Category } from '../../../../../shared/issuesV2';
import SBOM from './SBOM';

/**
 * SettingsOrganizationProjectIssues is the settings page for managing
 * the default issue settings for projects.
 */
const SettingsOrganizationProjectIssues: VoidFunctionComponent = () => {
  const { policies, isLoading } = usePolicies();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Header heading="Default Issue Settings" />
      <Licensing policies={policies[Category.Licensing]} />
      <Security policies={policies[Category.Vulnerability]} />
      <Quality policies={policies[Category.Quality]} />
      <SBOM policies={policies.SBOM} />
      <Containers />
    </>
  );
};

/**
 * SettingsOrganizationProjectIssuesContainer displays the project issue settings page if the user has permission to view it.
 */
const SettingsOrganizationProjectIssuesContainer: VoidFunctionComponent = () => (
  <OrganizationSettingsPermissionGate checkPermission={shouldDisplayProjectIssueSettings}>
    <SettingsOrganizationProjectIssues />
  </OrganizationSettingsPermissionGate>
);

export default SettingsOrganizationProjectIssuesContainer;
